import { ActionTypes } from '../../constants/ActionTypes';
import {
  IDataNode,
  ILetterReferTypesStaticsReducer,
  ILetterReferTypeStaticesKeysModel,
  ILetterReferTypeStaticesResponse,
} from '../../interfaces';

const INIT_STATE: ILetterReferTypesStaticsReducer = {
  letterReferInboxTypesStatics: [],
  letterReferSendBoxTypesStatics: [],
  dmsArchiveTree: [],
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.CLEAR_Letter_Refer_Inbox_Types_Statics: {
      return {
        ...state,
        letterReferInboxTypesStatics: [],
        letterReferInboxTypesStaticsLoading: false,
      };
    }

    case ActionTypes.FETCH_Letter_Refer_Inbox_Types_Statics_SUCCESS: {
      const lstTemp: ILetterReferTypeStaticesResponse[] = [];
      action.payload.map((item: ILetterReferTypeStaticesKeysModel) => {
        if (item.hasLetter === true && item.name) {
          lstTemp.push({
            title:
              item.letterUnreadCount > 0
                ? `${item.name} (${item.letterUnreadCount})`
                : item.name,
            key: {
              code: item.code,
              hasLetter: item.hasLetter,
              id: item.id,
              name: item.name,
              letterUnreadCount: 0,
            },
          });
        }
        return item;
      });
      return {
        ...state,
        letterReferInboxTypesStatics: lstTemp,
        letterReferInboxTypesStaticsLoading: false,
      };
    }

    case ActionTypes.GET_Letter_Refer_Inbox_Types_Statics: {
      return {
        ...state,
        letterReferInboxTypesStatics: [],
        letterReferInboxTypesStaticsLoading: true,
      };
    }

    //SendBox
    case ActionTypes.CLEAR_Letter_Refer_SendBox_Types_Statics: {
      return {
        ...state,
        letterReferSendBoxTypesStatics: [],
        letterReferSendBoxTypesStaticsLoading: false,
      };
    }

    case ActionTypes.FETCH_Letter_Refer_Sendbox_Types_Statics_SUCCESS: {
      const lstTemp: ILetterReferTypeStaticesResponse[] = [];
      action.payload.map((item: ILetterReferTypeStaticesKeysModel) => {
        if (item.hasLetter && item.name) {
          lstTemp.push({
            // title: item.letterUnreadCount > 0 ? `${item.name} (${item.letterUnreadCount})` : item.name,
            title: item.name,
            key: {
              code: item.code,
              name: item.name,
              id: item.id,
              hasLetter: item.hasLetter,
              letterUnreadCount: 0,
            },
          });
        }
        return item;
      });
      return {
        ...state,
        letterReferSendBoxTypesStatics: lstTemp,
        letterReferSendBoxTypesStaticsLoading: false,
      };
    }

    case ActionTypes.GET_Letter_Refer_SendBox_Types_Statics: {
      return {
        ...state,
        letterReferSendBoxTypesStatics: [],
        letterReferSendBoxTypesStaticsLoading: true,
      };
    }
    case ActionTypes.GET_DMS_TREE_MENU: {
      return {
        ...state,
        dmsArchiveTree: [],
        dmsArchiveTreeLoading: true,
      };
    }
    case ActionTypes.GET_DMS_TREE_MENU_SUCCESS: {
      const dmsTree = action.payload as IDataNode[];

      return {
        ...state,
        dmsArchiveTree: dmsTree,
        dmsArchiveTreeLoading: false,
      };
    }
    //SendBox
    default:
      return state;
  }
};
